import React, { useEffect, useState } from 'react';
import axios from '../../config/Axios';
import upload from '../../assets/images/upload-2.png';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { IG_APP_ID, BASEURL } from '../../helpers/constants';
import { Spin } from 'antd';
import { toast } from 'react-toastify';

const Pictures = ({
    formData,
    setFormData,
    handlePrev,
    handleNext,
    previewImages,
    setPreviewImages,
    isLastStep,
}) => {
    const { loading } = useSelector((state) => state.auth);
    const [images, setImages] = useState([]);
    const [accessToken, setAccessToken] = useState('');
    const [error, setError] = useState('');
    const [userImages, setUserImages] = useState([]);
    const path = window.location.pathname;
    const [isModalOpen, setIsModalOpen] = useState(false);
    const closeInstagramModal = () => setIsModalOpen(false);

    const getInstagramAccessTokenFromResponse = (responseData) => {
        const data = responseData?.data;
        if (Array.isArray(data)) {
            return data[0]?.access_token || '';
        }
        return (
            responseData?.access_token ||
            data?.access_token ||
            responseData?.response?.access_token ||
            ''
        );
    };

    const generateRandomName = () => {
        const timestamp = new Date().getTime();
        const randomString = Math.random().toString(36).substring(2, 8);

        return `${timestamp}_${randomString}.png`;
    };

    const setNewImages = (file, index) => {
        const newImages = [...images];
        newImages[index] = file;
        setImages(newImages);
        setFormData((prevFormData) => ({
            ...prevFormData,
            images: newImages,
        }));
    };

    const setAsReader = (file, index) => {
        const reader = new FileReader();
        reader.onloadend = () => {
            setPreviewImages((prevImages) => {
                const newImages = [...prevImages];
                newImages[index] = reader.result;
                return newImages;
            });
        };

        if (file) {
            reader.readAsDataURL(file);
        }
    };

    const processImages = async (storedFormData) => {
        const promises = storedFormData.images.map(async (image) => {
            const imageBlob = await fetch(image).then((response) =>
                response.blob()
            );
            const randomName = generateRandomName();
            return new File([imageBlob], randomName, {
                type: 'image/jpeg',
            });
        });

        const newFiles = await Promise.all(promises);
        console.log('new files', newFiles);
        setFormData((prevFormData) => ({
            ...prevFormData,
            images: newFiles,
        }));
        setImages(newFiles);
        newFiles.forEach((file, index) => {
            setAsReader(file, index);
        });
    };
    console.log('images', images);
    useEffect(() => {
        if (path.includes('upload-from-instagram')) {
            const exchangeCodeForToken = async (code) => {
                try {
                    const response = await axios.post('instagram/token', {
                        code,
                    });
                    const accessToken = getInstagramAccessTokenFromResponse(
                        response?.data
                    );
                    if (!accessToken) {
                        toast.error(
                            'Instagram token exchange succeeded but no access token was returned.'
                        );
                        return;
                    }
                    setAccessToken(accessToken);
                    sessionStorage.setItem(`ig_code_used_${code}`, '1');
                    window.history.replaceState(
                        {},
                        document.title,
                        window.location.pathname
                    );
                } catch (error) {
                    console.error(
                        'Error exchanging code for access token:',
                        error
                    );
                    const serverError = error?.response?.data;
                    toast.error(
                        serverError?.message ||
                            serverError?.errorCode ||
                            'Unable to connect Instagram right now. Please try again.'
                    );
                }
            };

            const urlParams = new URLSearchParams(window.location.search);
            const code = urlParams.get('code');
            console.log('code', code);
            if (code) {
                if (sessionStorage.getItem(`ig_code_used_${code}`)) {
                    toast.error(
                        'This Instagram authentication code is already used. Please reconnect Instagram.'
                    );
                    return;
                }
                exchangeCodeForToken(code);
            } else {
                toast.error(
                    'Instagram redirect is missing an authorization code. Please reconnect.'
                );
            }
        }
        if (window.location.pathname.includes('business-info')) {
            const storedFormData = JSON.parse(localStorage.getItem('formData'));

            if (storedFormData) {
                console.log('localSt ,storedFormData ', storedFormData.images);
                processImages(storedFormData);
                localStorage.removeItem('formData');
            }
        }
    }, [path]);

    useEffect(() => {
        const fetchUserImages = async () => {
            try {
                const response = await axios.get(
                    `https://graph.instagram.com/me/media?fields=id,media_type,media_url,thumbnail_url&access_token=${accessToken}`
                );
                let images = response.data.data;
                let filteredImages = images.filter(
                    (item) => item.media_type === 'IMAGE'
                );
                setUserImages(filteredImages);
                setIsModalOpen(true);
            } catch (error) {
                toast.error(
                    'Unable to fetch Instagram media. Please reconnect and try again.'
                );
                console.error('Error fetching user images:', error);
            }
        };

        if (accessToken) {
            fetchUserImages();
            const storedFormData = JSON.parse(localStorage.getItem('formData'));
            if (storedFormData) setFormData(storedFormData);
        }
    }, [accessToken]);

    const handleImageChange = (index, e) => {
        console.log('handleImageChange called');
        setError('');
        const file = e.target.files[0];
        const fileSize = file.size;

        const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg'];

        if (!allowedTypes.includes(file.type)) {
            setError('You can only upload an image file (JPEG, PNG, JPG)');
            e.target.value = '';
            return;
        }
        if (fileSize > 20000000) {
            setError('File size exceeds 20 megabytes.');
            e.target.value = '';
            return;
        }

        setNewImages(file, index);
        setAsReader(file, index);
    };

    const saveFormData = () => {
        localStorage.setItem('formData', JSON.stringify(formData));
        handleInstagramLogin();
    };

    const handleCheckboxChange = (index, image, url) => {
        if (images.length < 6 || images.includes(url)) {
            const newImages = [...images];

            if (newImages.includes(url)) {
                const indexToRemove = newImages.indexOf(url);
                newImages.splice(indexToRemove, 1);
            } else {
                newImages.push(url);
            }

            setImages(newImages);
            setFormData((prevData) => ({
                ...prevData,
                images: newImages,
            }));

            const updatedData = { ...formData, images: newImages };

            localStorage.setItem('formData', JSON.stringify(updatedData));
        }
    };

    const handleDeselect = (url) => {
        let newImages = [...images];
        newImages = newImages.filter((image) => image !== url);

        setImages(newImages);
        setFormData((prevData) => ({
            ...prevData,
            images: newImages,
        }));

        const updatedData = { ...formData, images: newImages };
        localStorage.setItem('formData', JSON.stringify(updatedData));
    };

    const handleImageSelection = (index, image, url) => {
        if (images.some((selectedImage) => selectedImage === url)) {
            handleDeselect(url);
        } else {
            handleCheckboxChange(index, image, url);
        }
    };

    const validateImageUpload = () => {
        if (
            !formData.image &&
            (!formData.images || formData.images.length === 0)
        ) {
            toast.warn('Please upload at least one image.');
            return false;
        }
        return true;
    };

    const handleInstagramLogin = () => {
        const clientId = IG_APP_ID;
        const redirectUri = 'https://next-salon.web.app/upload-from-instagram';
        const state = Math.random().toString(36).substring(7);

        const authUrl = new URL('https://www.instagram.com/oauth/authorize');
        authUrl.searchParams.append('client_id', clientId);
        authUrl.searchParams.append('redirect_uri', redirectUri);
        authUrl.searchParams.append(
            'scope',
            'instagram_business_basic,instagram_business_manage_messages,instagram_business_manage_comments,instagram_business_content_publish,instagram_business_manage_insights'
        );
        authUrl.searchParams.append('response_type', 'code');
        authUrl.searchParams.append('state', state);

        window.location.href = authUrl.toString();
    };

    return (
        <div className={`container-fluid max-w-md-605`}>
            <div
                className={`modal instagram-modal${!isModalOpen ? 'd-none' : ''
                    }`}
            >
                <div className={`instagram-modal-dialog`}>
                    <div className={`instagram-modal-content`}>
                        <button
                            type="button"
                            className="instagram-modal-close"
                            aria-label="Close"
                            onClick={closeInstagramModal}
                        >
                            ×
                        </button>
                        <h5
                            className={`color-primary poly f-36 fw-normal lh-48 mb-3`}
                        >
                            User Images
                        </h5>
                        <div className={`container`}>
                            <div
                                className={`row align-items-center justify-content-center max-h-500 overflow-auto `}
                            >
                                {userImages.map((image, index) => (
                                    <div
                                        key={image.id}
                                        className={`col-4 ps-0 pb-3`}
                                    >
                                        <label
                                            htmlFor={`image_${image.id}`}
                                            className={`position-relative cp`}
                                        >
                                            <img
                                                src={image.media_url}
                                                alt="User Image"
                                                className={`img-fluid br-5`}
                                            />
                                            <input
                                                type="checkbox"
                                                id={`image_${image.id}`}
                                                checked={images.some(
                                                    (selectedImage) =>
                                                        selectedImage ===
                                                        image.media_url
                                                )}
                                                onChange={() =>
                                                    handleImageSelection(
                                                        index,
                                                        image,
                                                        image.media_url
                                                    )
                                                }
                                                className={`position-absolute top-10 right-10`}
                                            />
                                        </label>
                                    </div>
                                ))}
                                <div className={`col-12 position-relative`}>
                                    {images.length >= 6 && (
                                        <p
                                            className={`password-error-text left-0`}
                                        >
                                            You can only select a maximum of 6
                                            images.
                                        </p>
                                    )}
                                </div>
                            </div>
                        </div>
                        <Link
                            className={`btn btn-next mt-4`}
                            to={`/business-info/${formData?.token}`}
                            onClick={closeInstagramModal}
                        >
                            Next
                        </Link>
                    </div>
                </div>
            </div>
            <div className={`row justify-content-center pb-md-40 pb-40`}>
                <div className={`col-md-12 px-0 text-center pt-4 pb-16`}>
                    <h5 className={`m-0 color-primary poly f-36 fw-normal lh-48`}>
                        Upload Images
                    </h5>
                </div>
                <div className="col-md-7 col-12 px-0 text-center lh-0 pb-16">
                    <span className="m-0 c-667085 poppins f-14 fw-normal lh-20">
                        Add your images so that user can see this
                        <br /> at your profile.
                    </span>
                </div>
                <button
                    type="button"
                    // href={`https://api.instagram.com/oauth/authorize?client_id=${IG_APP_ID}&redirect_uri=${BASEURL}/upload-from-instagram&scope=user_profile,user_media&response_type=code`}
                    className="col-md-7 col-12 px-0 text-center text-decoration-underline border-0 bg-transparent lh-0"
                    onClick={saveFormData}
                >
                    <div className={`container-fluid`}>
                        <div
                            className={`row justify-content-center align-items-center`}
                        >
                            <div className="col-auto ps-0 pe-2 text-center lh-0">
                                <svg
                                    width="25"
                                    height="24"
                                    viewBox="0 0 25 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M12.5 7.5C11.61 7.5 10.74 7.76392 9.99993 8.25839C9.25991 8.75285 8.68314 9.45566 8.34254 10.2779C8.00195 11.1002 7.91283 12.005 8.08647 12.8779C8.2601 13.7508 8.68868 14.5526 9.31802 15.182C9.94736 15.8113 10.7492 16.2399 11.6221 16.4135C12.495 16.5872 13.3998 16.4981 14.2221 16.1575C15.0443 15.8169 15.7471 15.2401 16.2416 14.5001C16.7361 13.76 17 12.89 17 12C16.9988 10.8069 16.5243 9.66303 15.6806 8.81939C14.837 7.97575 13.6931 7.50124 12.5 7.5ZM12.5 15C11.9067 15 11.3266 14.8241 10.8333 14.4944C10.3399 14.1648 9.95542 13.6962 9.72836 13.1481C9.5013 12.5999 9.44189 11.9967 9.55764 11.4147C9.6734 10.8328 9.95912 10.2982 10.3787 9.87868C10.7982 9.45912 11.3328 9.1734 11.9147 9.05764C12.4967 8.94189 13.0999 9.0013 13.6481 9.22836C14.1962 9.45542 14.6648 9.83994 14.9944 10.3333C15.3241 10.8266 15.5 11.4067 15.5 12C15.5 12.7956 15.1839 13.5587 14.6213 14.1213C14.0587 14.6839 13.2956 15 12.5 15ZM17 2.25H8C6.60807 2.25149 5.27358 2.80509 4.28933 3.78933C3.30509 4.77358 2.75149 6.10807 2.75 7.5V16.5C2.75149 17.8919 3.30509 19.2264 4.28933 20.2107C5.27358 21.1949 6.60807 21.7485 8 21.75H17C18.3919 21.7485 19.7264 21.1949 20.7107 20.2107C21.6949 19.2264 22.2485 17.8919 22.25 16.5V7.5C22.2485 6.10807 21.6949 4.77358 20.7107 3.78933C19.7264 2.80509 18.3919 2.25149 17 2.25ZM20.75 16.5C20.75 17.4946 20.3549 18.4484 19.6516 19.1516C18.9484 19.8549 17.9946 20.25 17 20.25H8C7.00544 20.25 6.05161 19.8549 5.34835 19.1516C4.64509 18.4484 4.25 17.4946 4.25 16.5V7.5C4.25 6.50544 4.64509 5.55161 5.34835 4.84835C6.05161 4.14509 7.00544 3.75 8 3.75H17C17.9946 3.75 18.9484 4.14509 19.6516 4.84835C20.3549 5.55161 20.75 6.50544 20.75 7.5V16.5ZM18.5 7.125C18.5 7.3475 18.434 7.56501 18.3104 7.75002C18.1868 7.93502 18.0111 8.07922 17.8055 8.16436C17.6 8.24951 17.3738 8.27179 17.1555 8.22838C16.9373 8.18498 16.7368 8.07783 16.5795 7.9205C16.4222 7.76316 16.315 7.56271 16.2716 7.34448C16.2282 7.12625 16.2505 6.90005 16.3356 6.69448C16.4208 6.48891 16.565 6.31321 16.75 6.1896C16.935 6.06598 17.1525 6 17.375 6C17.6734 6 17.9595 6.11853 18.1705 6.3295C18.3815 6.54048 18.5 6.82663 18.5 7.125Z"
                                        fill="#2b5c35"
                                    />
                                </svg>
                            </div>
                            <div className="col-auto px-0 text-center lh-0">
                                <span className="m-0 c-667085 poppins f-14 fw-normal lh-16 text-decoration-underline">
                                    Upload from Instagram
                                </span>
                            </div>
                        </div>
                    </div>
                </button>
            </div>
            <div className={`row`}>
                <div className={`col-12 px-md-0`}>
                    <div className={`max-w-512 mx-auto`}>
                        <div className={`row justify-content-center pb-20`}>
                            {[...Array(6)].map((_, index) => (
                                <div
                                    key={index}
                                    className={`col-md-4 col-auto pb-40 `}
                                >
                                    <label
                                        htmlFor={`formFile${index}`}
                                        className="form-label m-0 cp"
                                    >
                                        {previewImages[index] ? (
                                            <div className="max-wh-160px">
                                                <img
                                                    src={previewImages[index]}
                                                    alt="Preview"
                                                    className="br-16 dash-2-e1e6ef p-1 h-full w-full"
                                                    style={{
                                                        objectFit: 'cover',
                                                    }}
                                                />
                                            </div>
                                        ) : (
                                            <div className="max-wh-160px">
                                                <img
                                                    src={upload}
                                                    alt="Choose file"
                                                    className="h-full w-full"
                                                />
                                            </div>
                                        )}
                                        <input
                                            className="form-control d-none position-absolute"
                                            type="file"
                                            name="images[]"
                                            accept="image/jpeg, image/png, image/jpg"
                                            id={`formFile${index}`}
                                            onChange={(e) =>
                                                handleImageChange(index, e)
                                            }
                                        />
                                    </label>
                                </div>
                            ))}
                            <div className={`col-12 px-0 position-relative`}>
                                {error && (
                                    <p className={`password-error-text l-12`}>
                                        {error}
                                    </p>
                                )}
                            </div>
                        </div>
                        <div className={`row`}>
                            <div
                                className={`col-md-6 col-6 pr-md-7-5`}
                                onClick={handlePrev}
                            >
                                <button className={`btn btn-back`}>Back</button>
                            </div>
                            <div
                                className={`col-md-6 col-6 pl-md-7-5 pb-md-0 pb-3`}
                                onClick={() => {
                                    if (validateImageUpload()) {
                                        handleNext();
                                    }
                                }}
                            >
                                <button
                                    disabled={loading}
                                    className={`btn btn-next`}
                                >
                                    {loading ? <Spin /> : (isLastStep ? 'Submit' : 'Next')}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Pictures;
